import { render, staticRenderFns } from "./consumer-record.vue?vue&type=template&id=0eb562b4&"
import script from "./consumer-record.vue?vue&type=script&lang=ts&"
export * from "./consumer-record.vue?vue&type=script&lang=ts&"
import style0 from "./consumer-record.vue?vue&type=style&index=0&id=0eb562b4&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports